// Define mixin
const stringManagement = {
    methods: {
        /**
         * SECTION - Add comma to numbers
         * eg. 10000 -> 10,000
         */
        addCommaToNumber(number) {
            if (number == null) {
                return 0;
            }
            return number.toLocaleString("en");
        },

        /**
         * SECTION - Join hashtags together in a pretty string
         */
        createHashedHashtagString(hashtags) {
            return "#" + hashtags.join(" #");
        },

        /**
         * SECTION - Round to two decimal values
         */
        roundTwoDecimals(number) {
            return Math.round(number * 100) / 100;
        },

        /**
         * SECTION - Add K, M, G to numbers to make them pretty
         */
        abbreviateNumber(number) {
            var SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];

            // what tier? (determines SI symbol)
            var tier = (Math.log10(number) / 3) | 0;

            // if zero, we don't need a suffix
            if (tier == 0) return number;

            // get suffix and determine scale
            var suffix = SI_SYMBOL[tier];
            var scale = Math.pow(10, tier * 3);

            // scale the number
            var scaled = number / scale;

            // format number and add suffix
            return scaled.toFixed(1) + suffix;
        },
        calculateEngagement(likes, followers) {
            if (followers < 1) {
                return 0 + "%";
            }
            return this.roundTwoDecimals(100 * likes / followers) + "%";
        },

        /**
         * SECTION - Add "st", "th", "nd", to numbers
         */
        makeOrdinal(i) {
            var j = i % 10,
                k = i % 100;
            if (j == 1 && k != 11) {
                return i + "st";
            }
            if (j == 2 && k != 12) {
                return i + "nd";
            }
            if (j == 3 && k != 13) {
                return i + "rd";
            }
            return i + "th";
        },
    },
};

// Export
export default stringManagement;
